import { createRequest, hasUnauthorizedHandler } from "../request";
import { config } from "../config/env";

export const api = createRequest({
  baseURL: config.apiBaseUrl,
});

// Add token interceptor
api.addRequestInterceptor((config) => {
  if (typeof localStorage !== "undefined") {
    const token = localStorage.getItem("token");
    if (token) {
      if (config.headers instanceof Headers) {
        if (!config.headers.has("Authorization")) {
          config.headers.set("Authorization", token);
        }
      } else {
        // Fallback for plain object headers (though request.ts uses Headers)
        const headers = (config.headers as Record<string, string>) || {};
        if (!headers["Authorization"]) {
          config.headers = {
            ...headers,
            Authorization: token,
          };
        }
      }
    }
  }
  return config;
});

// Add error interceptor for invalid token
api.addErrorInterceptor((error) => {
  const data = error.data as any;
  if (data && data.code === "client.token.invalid") {
    if (hasUnauthorizedHandler()) {
      return;
    }

    // Clear token
    if (typeof localStorage !== "undefined") {
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
    }

    // Redirect to login page
    if (typeof window !== "undefined" && !window.location.pathname.includes("/login")) {
      window.location.href = "/login";
    }
  }
});
